import React from "react";
import { observer } from "mobx-react";
import { InterpreterViewStore } from "../../store";
import { InterpreterViewForm } from "./InterpreterViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type InterpreterViewProps = {
  interpreterViewStore: InterpreterViewStore;
};

export const InterpreterView: React.FC<InterpreterViewProps> = observer(
  ({ interpreterViewStore }) => {
    return (
      <div>
        <InterpreterViewForm
          interpreterViewStore={interpreterViewStore}
          name={interpreterViewStore.nameValue}
          createdAt_={interpreterViewStore.createdAt_Value}
          lastUpdatedAt_={interpreterViewStore.lastUpdatedAt_Value}
          onPrint={(handlePrint: () => void) =>
            interpreterViewStore.printInterpreter(handlePrint)
          }
          onCancel={() => interpreterViewStore.cancelInterpreter()}
          onEdit={
            interpreterViewStore.isEditEnabled
              ? () => interpreterViewStore.editInterpreter()
              : undefined
          }
        />
        <ErrorDialog
          open={interpreterViewStore.errorDialogOpened}
          title={interpreterViewStore.errorTitle}
          description={interpreterViewStore.errorDescription}
          onClose={() => interpreterViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
